<div class="page-title-area">
    <img src="assets/images/apple_ecosystem_banner.png" alt="Page Background" class="page-bg">
    <button class="back-arrow-btn" (click)="navigateToHome()">
        <i class="fas fa-chevron-left fa-2x"></i>
    </button>
    <div class="container">
        <div class="page-title-content">
            <h2>Apple Ecosystem Consulting</h2>
        </div>
    </div>

   <!--  <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div> -->
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="scrives-item-2 mt-4 ">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                    <div class="services-img mb-qc ios-content">
                        <div class="circular-layout">
                            <div class="image-container">
                              <img src="assets/images/apple_ecosystme1.png" alt="image" class="image-container-img"/>
                            </div>
                          </div>
                       <!--  <div class="image-wrapper">
                            <div class="background-shape shape1"></div>
                            <div class="background-shape shape2"></div>
                            <img src="assets/images/net2.png" alt="Person">
                        </div> -->
                    </div>
                </div>

                <div class="col-lg-6">
                    <h2>Ecosystem Consulting</h2>
                  <p>Maximise your ROI with expert Apple ecosystem planning.</p>
                  <p>We help you align Apple devices, software, and services with your business objectives for seamless workflows and higher productivity.</p>
                  <p>From device strategy and MDM implementation to app ecosystem design, our consultants tailor everything to your operational needs.</p>
                  <p>We work closely with your teams to ensure a smooth, scalable, and secure Apple environment.</p>
                  <p>Let’s build a digital ecosystem that works as hard as you do.</p>
              </div>
            </div>
        </div>

    </div>
</section>

<div class="container mb-4">
    <div class="d-flex justify-content-end">
        <button class="btn back-btn" (click)="navigateToHome()">
            <i class="fas fa-arrow-left me-2"></i> Back to Home
        </button>
    </div>
</div>
